import axios from "../../utils/axiosInstance";

export const createEmailNotificationObjectReactive = async (zenGroupId, notifyAllGroupMembers, emailAddressesToAlert, userSetName, timeInterval, ransomwareActivity, non_RansomwareIntrusionActivity,
                                                            offlineAgent, autoGeneratedAVWhitelist, sendOfflineAlertsForHiddenAgents, sendRansomwareActivityAlertsForSilentIncidents,
                                                            newAgentVersion, partiallyOfflineAgent, attachFileWithEmailAlert) => {
    return await axios.post("/createEmailNotificationObjectReactive", {
        zenGroupId: zenGroupId,
        notifyAllGroupMembers: notifyAllGroupMembers,
        emailAddressesToAlert: emailAddressesToAlert,
        userSetName: userSetName,
        timeInterval: timeInterval,
        ransomwareActivity: ransomwareActivity,
        non_RansomwareIntrusionActivity: non_RansomwareIntrusionActivity,
        offlineAgent: offlineAgent,
        partiallyOfflineAgent: partiallyOfflineAgent,
        autoGeneratedAVWhitelist: autoGeneratedAVWhitelist,
        newAgentVersion: newAgentVersion,
        sendOfflineAlertsForHiddenAgents: sendOfflineAlertsForHiddenAgents,
        sendRansomwareActivityAlertsForSilentIncidents: sendRansomwareActivityAlertsForSilentIncidents,
        attachFileWithEmailAlert: attachFileWithEmailAlert,
    });
};

export const notificationsListReactive = async () => {
    const response = await axios.post("/notificationsListReactive", {
    });
    return response.data;
};
export const deleteSingleSecurityNotificationReactive = async (securityNotificationId) => {
    return await axios.post("/deleteSingleSecurityNotificationReactive", {
        securityNotificationId: securityNotificationId
    });
};

export const updateNotificationTypeReactive = async (zenGroupId, notificationId, specificType, newSetting) => {
    return await axios.post("/updateNotificationTypeReactive", {
        zenGroupId: zenGroupId,
        notificationId: notificationId,
        specificType: specificType,
        newSetting: newSetting
    });
};

export const updateNotificationTimeIntervalReactive = async (zenGroupId, timeInterval, notificationId) => {
    return await axios.post("/updateNotificationTimeIntervalReactive", {
        zenGroupId: zenGroupId,
        notificationId: notificationId,
        newTimeInterval: timeInterval
    });
};
export const updateSecurityNotificationNameReactive = async (newName, emailNotificationId) => {
    return await axios.post("/updateSecurityNotificationNameReactive", {
        newName: newName,
        emailNotificationId: emailNotificationId
    });
};
export const findBySecurityNotificationIdListReactive = async (ids) => {
    const response = await axios.post("/findBySecurityNotificationIdListReactive",{
        ids
    })
    return response.data
}
export const singleUpdateSecurityNotificationSendHiddenAgentAlertsReactive = async (notificationId, sendOfflineAlertsForHiddenAgents) => {
    return await axios.post("/singleUpdateSecurityNotificationSendHiddenAgentAlertsReactive", {
        notificationId: notificationId,
        sendOfflineAlertsForHiddenAgents: sendOfflineAlertsForHiddenAgents
    });
};
export const singleUpdateSecurityNotificationSendRansomwareActivityAlertsForSilentIncidentsReactive = async (notificationId, sendRansomwareActivityAlertsForSilentIncidents) => {
    return await axios.post("/singleUpdateSecurityNotificationSendRansomwareActivityAlertsForSilentIncidentsReactive", {
        notificationId: notificationId,
        sendRansomwareActivityAlertsForSilentIncidents: sendRansomwareActivityAlertsForSilentIncidents
    });
};
export const updateSecurityNotificationAttachFileWithEmailReactive = async (notificationId, attachFileWithEmailAlert) => {
    return await axios.post("/updateSecurityNotificationAttachFileWithEmailReactive", {
        notificationId: notificationId,
        attachFileWithEmailAlert: attachFileWithEmailAlert
    });
};
export const addEmailAddressToSecurityNotificationListReactive = async (notificationId, emailAddressesToAlert) => {
    return await axios.post("/addEmailAddressToSecurityNotificationListReactive", {
        notificationId: notificationId,
        emailAddressesToAlert: emailAddressesToAlert
    });
};
export const removeEmailAddressFromSecurityNotificationListReactive = async (notificationId, emailAddressesToAlert) => {
    return await axios.post("/removeEmailAddressFromSecurityNotificationListReactive", {
        notificationId: notificationId,
        emailAddressesToAlert: emailAddressesToAlert
    });
};

export const getSecurityNotificationsGridFilterStateReactive = async () => {
    const response =  await axios.post("/getSecurityNotificationsGridFilterStateReactive", {});
    return response.data;
};

export const updateSecurityNotificationsGridFilterModelReactive = async (newFilterModel) => {
    return await axios.post("/updateSecurityNotificationsGridFilterModelReactive", {
        newFilterModel: newFilterModel
    });
};

export const updateSecurityNotificationsGridUseFilterStateReactive = async (newUseFilterState) => {
    return await axios.post("/updateSecurityNotificationsGridUseFilterStateReactive", {
        newUseFilterState: newUseFilterState
    });
};

export const getSecurityNotificationsGridColumnStateReactive = async () => {
    const response =  await axios.post("/getSecurityNotificationsGridColumnStateReactive", {});
    return response.data;
};
export const updateSecurityNotificationsGridColumnStateReactive = async (columnStatesList) => {
    return await axios.post("/updateSecurityNotificationsGridColumnStateReactive", {
        columnStatesList: columnStatesList
    });
};

export const updateSecurityNotificationsGridUseColumnStateReactive = async (newUseColumnState) => {
    return await axios.post("/updateSecurityNotificationsGridUseColumnStateReactive", {
        newUseColumnState: newUseColumnState
    });
};
export const generateMonthlyReport = async () => {
    return await axios.post("/generateMonthlyReport", {});
};

export const updateSecurityNotificationsGridColumnModeReactive = async (columnMode) => {
    return await axios.post("/updateSecurityNotificationsGridColumnModeReactive", {
        columnMode: columnMode
    });
};

export const ccRetrieveUsernamesReactive = async () => {
    const response =  await axios.post("/ccRetrieveUsernamesReactive", {});
    return response.data;
};
export const ccGenerateMonthlyReportForCustomerReactive = async (username) => {
    const response =  await axios.post("/ccGenerateMonthlyReportForCustomerReactive", {
        username: username
    });
    return response.data;
};